



















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import registerHf from "@/services/registerHf";
import PanggilanPoli from "@/services/panggilan/PanggilanPoli";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";

@Component({})
export default class Report extends Vue {
  message = `Klik tautan di bawah ini untuk melaporkan kerusakan/ pertanyaan terkait aplikasi RME atau komputer di ruangan Anda:`;
  nb = `NB: Bila link tersebut tidak bekerja, laporan dapat dilakukan dengan kirim chat ke WA-Gateway SIMRS di nomor: 089510778377 (format: #laporsim <spasi> pesan)`;
  runText = "";
  sendingRunText = false;

  get activeUnit() {
    return userModule.user.unit_group_id;
  }

  async sendRunningText() {
    if (!this.sendingRunText) {
      this.sendingRunText = true;

      await PanggilanPoli.setRunningText({
        unit_id: userModule.user.unit_id,
        message: this.runText
      })
        .then(resp => {
          if (resp.data.status) {
            appModule.sendSuccessNotice(
              "Berhasil update pemberitahuan running text!"
            );
          }
        })
        .finally(() => {
          this.sendingRunText = false;
        });
    }
  }
}
